@if (!isNew) {
	<app-record-header
		[recordData]="recordData()"
		[moduleName]="'vehicles|title'"
		[module]="module"
		[headerData]="headerData"
		[isNew]="isNew"
		[isSaving]="isSaving"
		[isEditMode]="isEditMode"
		(onEdit)="onEditClicked()"
		(onSave)="onSaveClicked()"
		(onCancel)="onCancelClicked()"
		(onTitleClick)="onTitleClicked()"
		[isSaveButtonActive]="isSaveButtonActive"
		[isStacked]="isStacked()"
		[savedWhileEditing]="savedWhileEditing()">
		<div class="record-menu">
			<app-vehicles-list-item-menu
				#recordListMenu
				[isEditMode]="isEditMode"
				[item]="recordData()" />
		</div>
	</app-record-header>
}
<ion-content [scrollY]="false" [scrollX]="false">
	<ion-nav #nav />
</ion-content>

<ng-template #tabsBody>
	@if (!isNew) {
		<app-record-tabs
			pane-body
			[selectedTab]="recordTab"
			[moduleEnum]="this.module"
			[id]="this.recordData().id"
			[isNew]="isNew"
			[recordTabs]="recordTabs"
			(viewDetails)="showMoreSections()">
			<ng-template [tabContent]="recordTabs.overview.value">
				<ng-container [ngTemplateOutlet]="overview"></ng-container>
			</ng-template>
			<ng-template [tabContent]="recordTabs.links.value">
				<app-module-selector
					[nav]="nav"
					[isNew]="isNew"
					[recordId]="recordData().id" />
			</ng-template>
			<ng-template [tabContent]="recordTabs.activity.value">
				<app-no-activity />
			</ng-template>
		</app-record-tabs>
	}
</ng-template>
<ng-template #overview>
	@if (recordData()?.type !== vehicleTypeEnum.BICYCLE && !isNew) {
		<app-vehicle-actions
			[nav]="nav"
			[recordData]="recordData()"
			[isEditMode]="isEditMode" />
	}
	<app-vehicles-summary
		[isNew]="isNew"
		[statusTracking]="recordData().statusTracking"
		[recordData]="recordData()"
		[isEditMode]="isEditMode"
		(sectionChanged)="sectionDataChangedHandler($event)" />
	@if (!isNew) {
		<app-vehicle-next-operation [vehicleId]="recordData().id" />
	}
	<app-annotations-section
		[recordData]="recordData()"
		[isNew]="isNew"
		[isEditMode]="true"
		(sectionChanged)="
			sectionDataChangedHandler($event); isNew ? null : saveSection()
		" />
</ng-template>

<ng-template #moreSections>
	@if (!isNew) {
		<app-more-details
			[nav]="nav"
			[isNew]="isNew"
			[footer]="recordFooter"
			[projectedSections]="recordSections()"
			[errors]="errorMessages | async"
			(onBack)="navToTabs()">
		</app-more-details>
	} @else {
		<app-stepper
			[overview]="overview"
			[isStacked]="isStacked()"
			[newSaveButton]="newSaveButton"
			[errors]="errorMessages | async"
			[title]="'vehicles|add-title'"
			[projectedSections]="recordSections()" />
	}
</ng-template>

<ng-template #newSaveButton>
	<button
		[disabled]="!isSaveButtonActive || isSaving"
		(click)="onSaveClicked()"
		color="primary"
		type="button"
		ultra-primary
		svgIcon="check"></button>
</ng-template>

<ng-template #recordFooter>
	<app-context-info [numberOfErrors]="(errorMessages | async)?.length">
		<ng-content select=".context-info-extras"></ng-content>
		<app-errors-box [errorMessages]="errorMessages | async" />
	</app-context-info>

	<ion-fab slot="fixed">
		<app-record-footer
			[isSaving]="isSaving"
			[isEditMode]="isEditMode"
			[isDeleted]="false"
			[isSaveButtonActive]="isSaveButtonActive"
			(onEdit)="onEditClicked()"
			(onSave)="onSaveClicked()"
			(onCancel)="onCancelClicked()" />
	</ion-fab>
</ng-template>

@if (isNew) {
	<ng-template
		[appSectionMetadata]="{
			title: 'shared|class-title',
		}">
		<app-type-section
			[isEditMode]="isEditMode"
			[isNew]="isNew"
			[recordData]="recordData()"
			[options]="typeOptions"
			(sectionChanged)="sectionDataChangedHandler($event)" />
	</ng-template>
}

<ng-template
	[appSectionMetadata]="{
		title: 'vehicles|record|details-section|title',
	}">
	<app-vehicles-details
		[recordData]="recordData()"
		[isNew]="isNew"
		[isEditMode]="isEditMode"
		(sectionChanged)="sectionDataChangedHandler($event)" />
</ng-template>

@if (features.locations && originModule() !== modulesEnum.LOCATIONS) {
	<ng-template
		[appSectionMetadata]="{
			title: 'locations|display-section|title',
		}">
		<app-location-section
			[recordData]="recordData()"
			[isNew]="isNew"
			[isEditMode]="isEditMode"
			(sectionChanged)="sectionDataChangedHandler($event)" />
	</ng-template>
}

@if (
	features.vehicleCategories &&
	originModule() !== modulesEnum.VEHICLE_CATEGORIES
) {
	<ng-template
		[appSectionMetadata]="{
			title: 'vehicle-categories|display-section|title',
		}">
		<app-vehicle-category-section
			[recordData]="recordData()"
			[isNew]="isNew"
			[isEditMode]="isEditMode"
			(sectionChanged)="sectionDataChangedHandler($event)" />
	</ng-template>
}

@if (features.suppliers && originModule() !== modulesEnum.SUPPLIERS) {
	<ng-template
		[appSectionMetadata]="{
			title: 'suppliers|display-section|title',
		}">
		<app-supplier-section
			[recordData]="recordData()"
			[isNew]="isNew"
			[isEditMode]="isEditMode"
			(sectionChanged)="sectionDataChangedHandler($event)" />
	</ng-template>
}

<ng-template
	[appSectionMetadata]="{
		title: 'vehicles|record|make-model-section|title',
	}">
	<app-vehicles-make-model
		[recordData]="recordData()"
		[isNew]="isNew"
		[isEditMode]="isEditMode"
		(sectionChanged)="sectionDataChangedHandler($event)" />
</ng-template>

<ng-template
	[appSectionMetadata]="{
		title: 'vehicles|record|purchase-details-section|title',
	}">
	<app-vehicles-purchase-details
		[recordData]="recordData()"
		[isNew]="isNew"
		[isEditMode]="isEditMode"
		(sectionChanged)="sectionDataChangedHandler($event)" />
</ng-template>

<ng-template
	[appSectionMetadata]="{
		title: 'vehicles|record|extras-section|title',
	}">
	<app-extra-features-section
		[recordData]="recordData()"
		[isNew]="isNew"
		[isEditMode]="isEditMode"
		(sectionChanged)="sectionDataChangedHandler($event)" />
</ng-template>

<ng-template
	[appSectionMetadata]="{
		title: 'vehicles|record|color-section|title',
	}">
	<app-vehicles-color
		[recordData]="recordData()"
		[isNew]="isNew"
		[isEditMode]="isEditMode"
		(sectionChanged)="sectionDataChangedHandler($event)" />
</ng-template>
@if (recordData()?.type !== vehicleTypeEnum.BICYCLE) {
	<ng-template
		[appSectionMetadata]="{
			title: 'vehicles|record|power-plant-section|title',
		}">
		<app-vehicles-power-plant
			[isNew]="isNew"
			[isEditMode]="isEditMode"
			[recordData]="recordData()"
			(sectionChanged)="sectionDataChangedHandler($event)" />
	</ng-template>
	<ng-template
		[appSectionMetadata]="{
			title: 'vehicles|record|engine-section|title',
		}">
		<app-vehicles-engine
			[recordData]="recordData()"
			[isNew]="isNew"
			[isEditMode]="isEditMode"
			(sectionChanged)="sectionDataChangedHandler($event)" />
	</ng-template>
	<ng-template
		[appSectionMetadata]="{
			title: 'vehicles|record|motor-section|title',
		}">
		<app-vehicles-motor
			[recordData]="recordData()"
			[isNew]="isNew"
			[isEditMode]="isEditMode"
			(sectionChanged)="sectionDataChangedHandler($event)" />
	</ng-template>
	<ng-template
		[appSectionMetadata]="{
			title: 'vehicles|record|emissions-section|title',
		}">
		<app-vehicles-emissions
			[recordData]="recordData()"
			[isNew]="isNew"
			[isEditMode]="isEditMode"
			(sectionChanged)="sectionDataChangedHandler($event)" />
	</ng-template>
}

<ng-template
	[appSectionMetadata]="{
		title: 'shared|comments|title',
	}">
	<app-comments-section
		[isNew]="isNew"
		[recordData]="recordData()"
		[isEditMode]="isEditMode"
		(sectionChanged)="sectionDataChangedHandler($event)" />
</ng-template>

<!-- @if (isNew) {
	<ng-template
		[appSectionMetadata]="{
			title: 'shared|annotations',
		}">
		<app-annotations-section
			[isNew]="isNew"
			[recordData]="recordData()"
			[isEditMode]="isEditMode"
			(sectionChanged)="sectionDataChangedHandler($event)" />
	</ng-template>
} -->
